import {Component} from '@angular/core';

@Component({
  selector: 'app-not-complete',
  templateUrl:'./not-complete.page.html'
})
export class NotCompletePageComponent{
}
